(function () {

    var tsUsersService;
    var shiftTemplateUtils;
    var scheduleDataServiceV2;
    var _businessDayUtils;
    var _workRestrictionsService;

    function MinorSchedulingService () {
        var self = this;

        const MILLISECOND = 1000;

        self.usersMinorTypes = {};
        self.usersMinorEmancipationStatus = {};
        self.usersMinorRestrictedStatus = {};
        self.shiftsMinorTypes = {};
        self.minorsWarning = {};
        self.minorWarningsPerShift = {};
        var minorUsersWorkMap = {};
        self.minorWorkPermitsSetting = {};

        var updateShiftMinorType = function (shift) {
            var userInfo = tsUsersService.users[shift.user_id];
            var isMinor = userInfo && userInfo.isMinor(shift.day);

            if (isMinor) {
                var userMinorTypes = self.usersMinorTypes[shift.user_id];

                if (userMinorTypes && userMinorTypes.length) {
                    for (var i = 0; i < userMinorTypes.length; i++) {
                        var userMinorType = userMinorTypes[i];

                        if (
                            moment(shift.startTime).isSameOrAfter(userMinorType.start_date) &&
                            (!userMinorType.end_date || moment(shift.startTime).isSameOrBefore(userMinorType.end_date))
                        ) {
                            self.shiftsMinorTypes[shift.id] = userMinorType;
                        }
                    }
                }
            }
        };

        self.getUserEmancipationStatuses = function (userId) {
            if (self.usersMinorEmancipationStatus && self.usersMinorEmancipationStatus[userId]) {
                return self.usersMinorEmancipationStatus[userId];
            }
            return null;
        };

        self.parseMinorWorkPermitsSetting = (settings) => {
            self.minorWorkPermitsSetting = settings;
        }

        self.getUserRestrictedStatuses = function (userId) {
            if (self.usersMinorRestrictedStatus && self.usersMinorRestrictedStatus[userId]) {
                return self.usersMinorRestrictedStatus[userId];
            }
            return null;
        };

        self.getEffectiveMinorUserStatus = function (userMinorStatuses, startTime) {
            if (!userMinorStatuses || !userMinorStatuses.length) {
                return;
            }

            for (var i = 0; i < userMinorStatuses.length; i++) {
                var userMinorStatus = userMinorStatuses[i];

                if (
                    moment(startTime).isSameOrAfter(userMinorStatus.start_date) &&
                    (!userMinorStatus.end_date || moment(startTime).isSameOrBefore(userMinorStatus.end_date))
                ) {
                    return userMinorStatus;
                }
            }
        };

        self.parseBrandMinorsRules = function (rulesList) {
            self.minorsWorkRules = [];

            for (var i in rulesList) {
                var ruleDetails = rulesList[i];
                var preparedRule = {
                    from_age: ruleDetails.from_age,
                    to_age: ruleDetails.to_age,
                    rule_properties: _workRestrictionsService.prepareWorkRestrictionsRules(ruleDetails.minor_work_rule_properties),
                    minor_type: ruleDetails.minor_type,
                    legal_status: ruleDetails.legal_status
                };

                self.minorsWorkRules.push(preparedRule);
            }
        };

        let isDateInPeriods = (date, periods) => {
            return periods.some(period => {
                let start = moment(period.start_date);
                let end = period.end_date ? moment(period.end_date) : null;
                return date.isSameOrAfter(start, 'day') && (!end || end && date.isSameOrBefore(end, 'day'));
            });
        }

        self.parseMinorUsersWorkPermits = (usersWorkPermits, startOfWeek)  => {
            let startOfCalenderWeek = moment(startOfWeek, 'MMM DD, YYYY');
            let endOfWeekDate = startOfCalenderWeek.clone().add(6, 'days').format('MMM DD, YYYY');
            self.minorUsersWorkPermitsMap = {};

            for (let i in usersWorkPermits) {
                let user = usersWorkPermits[i];
                let minorWorkPermits = user.minor_work_permits || {};
                for (let m = startOfCalenderWeek.clone(); m.isSameOrBefore(endOfWeekDate); m.add(1, 'days')) {
                    let formattedDay = m.format('MMM DD, YYYY');
                    self.minorUsersWorkPermitsMap[user.id] ??= {};
                    self.minorUsersWorkPermitsMap[user.id][formattedDay] = {
                        has_work_permit: isDateInPeriods(m, minorWorkPermits.work_permits_periods || []),
                        is_exempt: isDateInPeriods(m, minorWorkPermits.exempts_periods || [])
                    };
                }
            }
        }

        let getNonCompliantWorkPermitDateRange = (userId, weekDaysKeys) => {

            if (!self.minorUsersWorkPermitsMap[userId]) {
                return { fromDate: weekDaysKeys[0], toDate: weekDaysKeys[weekDaysKeys.length - 1] };
            }
            else {
                let daysWithoutPermitOrExempt = [];

                for (let date in self.minorUsersWorkPermitsMap[userId]) {
                    let dayInfo = self.minorUsersWorkPermitsMap[userId][date];
                    if (!dayInfo.has_work_permit && !dayInfo.is_exempt) {
                        daysWithoutPermitOrExempt.push(date);
                    }
                }

                if (daysWithoutPermitOrExempt.length === 0) {
                    return null;
                } else {
                    let fromDate = daysWithoutPermitOrExempt[0];
                    let toDate = daysWithoutPermitOrExempt[daysWithoutPermitOrExempt.length - 1];
                    return { fromDate, toDate };
                }
            }

        }

        self.parseMinorUsersSchoolTemplates = function (startOfWeek, usersSchoolTemplates, brandMinorTypes) {
            var startOfCalenderWeek = moment(startOfWeek, 'MMM DD, YYYY');
            var endOfWeekDate = startOfCalenderWeek.clone().add(6, 'days').format('MMM DD, YYYY');
            self.usersMinorTypes = {};
            self.usersMinorEmancipationStatus = {};
            self.usersMinorRestrictedStatus = {}

            for (var i = 0; i < usersSchoolTemplates.length; i++) {
                var user = usersSchoolTemplates[i];

                for (var j = 0; j < user.minor_school_templates.length; j++) {
                    var template = user.minor_school_templates[j];
                    var minorSchoolTemplateStartDate = moment(template.start_date, "YYYY-MM-DDTHH:mm:ss");
                    var minorSchoolTemplateEndDate = template.end_date ? moment(template.end_date, "YYYY-MM-DDTHH:mm:ss").endOf('day') : null;
                    var userAge = tsUsersService.users[user.id] && tsUsersService.users[user.id].getUserAge(startOfCalenderWeek);

                    if (
                        userAge < 18 &&
                        (
                            moment(startOfCalenderWeek).isSameOrAfter(minorSchoolTemplateStartDate) &&
                            (!minorSchoolTemplateEndDate || moment(startOfCalenderWeek).isSameOrBefore(minorSchoolTemplateEndDate))
                        ) ||
                        (
                            moment(minorSchoolTemplateStartDate).isSameOrAfter(startOfCalenderWeek) &&
                            moment(minorSchoolTemplateStartDate).isSameOrBefore(endOfWeekDate)
                        )
                    ) {
                        self.usersMinorTypes[user.id] = self.usersMinorTypes[user.id] || [];
                        self.usersMinorEmancipationStatus[user.id] = self.usersMinorEmancipationStatus[user.id] || [];
                        self.usersMinorRestrictedStatus[user.id] = self.usersMinorRestrictedStatus[user.id] || [];

                        if (template.minor_type) {
                            var minorTypeDetails = _.findWhere(brandMinorTypes, {id: template.minor_type.id});
                            if (minorTypeDetails) {
                                template.minor_type['require_school_template'] = minorTypeDetails.require_school_template;
                                template.minor_type['start_date'] = minorSchoolTemplateStartDate;
                                template.minor_type['end_date'] = minorSchoolTemplateEndDate;
                                template.minor_type['minor_age'] = userAge;
                                self.usersMinorTypes[user.id].push(template.minor_type);
                            }
                        }

                        self.usersMinorEmancipationStatus[user.id].push({
                            end_date: minorSchoolTemplateEndDate,
                            is_emancipated: template.is_emancipated,
                            start_date: minorSchoolTemplateStartDate,
                        })

                        if (template.brand_user_restriction_rule_properties && template.brand_user_restriction_rule_properties.length) {
                            template.brand_user_restriction_rule_properties.forEach(function (property) {
                                property.status = 'ACTIVE';
                            })
                        }

                        self.usersMinorRestrictedStatus[user.id].push({
                            end_date: minorSchoolTemplateEndDate,
                            is_restricted: template.is_restricted,
                            start_date: minorSchoolTemplateStartDate,
                            brand_user_restriction_rule_properties: _workRestrictionsService.prepareWorkRestrictionsRules(template.brand_user_restriction_rule_properties),
                        })
                    }
                }
            }
        };

        self.prepareMinorDetailsMap = function (viewType, selectedDate) {
            var minorDetailsMap = {};

            for (var i in self.usersMinorTypes) {
                var minorInfo = [];
                var minorTypes = self.usersMinorTypes[i];
                var appliedMinorTypes = [];

                if (minorTypes.length) {
                    for (var minorTypeIndex = 0; minorTypeIndex < minorTypes.length; minorTypeIndex++) {
                        var minorType = minorTypes[minorTypeIndex];

                        if (
                            viewType === 'WEEKLY' ||
                            (
                                moment(selectedDate).isSameOrAfter(minorType.start_date) &&
                                (!minorType.end_date || moment(selectedDate).isSameOrBefore(minorType.end_date))
                            )
                        ) {
                            var minorDetail = minorType.name + ' ' + $filter('translate')('minor employee');

                            if (viewType === 'WEEKLY') {
                                var minorTypeEndDate = minorType.end_date ? moment(minorType.end_date).format('DD MMM') : '';
                                minorDetail += '[ ' + moment(minorType.start_date).format('DD MMM') + '-' + minorTypeEndDate + ' ]';
                            }
                            minorDetail += ' ,';
                            minorInfo.push(minorDetail);
                            appliedMinorTypes.push(minorType)
                        }

                    }

                    if (minorInfo.length) {
                        minorInfo.push($filter('translate')('age') + ' ' + minorTypes[0].minor_age + ' ' + $filter('translate')('years old') + '.');
                        minorDetailsMap[i] = {info: minorInfo.join(''), minor_types: appliedMinorTypes};
                    }
                }
            }

            return minorDetailsMap;
        };
        var getMinorRulesSet = function (minorsWorkRules, useAge, userMinorType, isEmancipated, restrictedMinorStatus) {
            var minorRule;

            minorRule = _.find(minorsWorkRules, function (rule) {
                return (
                    (useAge >= rule.from_age) &&
                    (useAge < rule.to_age) &&
                    rule.minor_type &&
                    userMinorType &&
                    rule.minor_type.id === userMinorType.id &&
                    (
                        rule.legal_status === 'ALL' ||
                        (rule.legal_status === 'UNEMANCIPATED' && !isEmancipated) ||
                        (rule.legal_status === 'EMANCIPATED' && isEmancipated)
                    )
                );
            });


            return prepareCombinedRestrictedMinorRule(minorRule, restrictedMinorStatus);
        };

        var prepareCombinedRestrictedMinorRule = function (minorTypeRule, restrictedMinorStatus) {
            if (!restrictedMinorStatus || !restrictedMinorStatus.is_restricted) {
                return minorTypeRule && minorTypeRule['rule_properties'];
            }

            var minorRuleProperties = minorTypeRule && angular.copy(minorTypeRule['rule_properties']) || {};

            for (var property in restrictedMinorStatus.brand_user_restriction_rule_properties) {
                var ruleProperty = restrictedMinorStatus.brand_user_restriction_rule_properties[property];
                for (var key in ruleProperty) {
                    if (minorRuleProperties[property]) {
                        minorRuleProperties[property][key] = ruleProperty[key];
                    } else {
                        minorRuleProperties[property] = ruleProperty;
                    }
                }
            }

            return minorRuleProperties;
        }

        const getTotalWorkHoursWithinPreviousPeriod = (currentShift, previousShifts, period, lastDayShiftsInPreviousWeek) => {
            let totalWorkWithinPeriod = currentShift.length;
            if (period === -24 || period === -12) {
                var endPeriod = moment(currentShift.end_time, "MMM DD, YYYY HH:mm").subtract(Math.abs(period), 'hours').valueOf();
                var currentShiftEndTime = Date.parse(currentShift.end_time);
            }
            const prevShifts = {...previousShifts?.shifts} || {};
            if (lastDayShiftsInPreviousWeek.length > 0) {
                const day = lastDayShiftsInPreviousWeek[0].day;
                prevShifts[day] ??= [];
                prevShifts[day] = [...lastDayShiftsInPreviousWeek, ...prevShifts[day]];
            }
            for (let day in prevShifts) {
                for (let shiftToCompare of prevShifts[day]) {
                    const shiftEndTime = Date.parse(shiftToCompare.end_time);
                    const shiftStartTime = Date.parse(shiftToCompare.start_time);

                    const isShiftIncludedInSpecificPeriod = shiftToCompare.id !== currentShift.id
                        && (shiftStartTime < currentShiftEndTime)
                        && (shiftEndTime > endPeriod);
                    if (isShiftIncludedInSpecificPeriod) {
                        const latestTime = Math.max(endPeriod, shiftStartTime);
                        totalWorkWithinPeriod += (shiftEndTime - latestTime) / MILLISECOND;
                    }
                }
            }
            return totalWorkWithinPeriod;
        };

        const getMaxDurationHoursBetweenShifts = (shiftsByDay, firstDayOfWeek, lastDayOfWeek, birthDate, lastShiftInPreviousWeek) => {
            if (self.minorsWorkRules.length <= 0) {
                return;
            }
            const allShifts = [];
            for (const day in shiftsByDay) {
                allShifts.push(...shiftsByDay[day]);
            }
            if (allShifts.length <= 0) {
                return;
            }
            allShifts.sort((a, b) => a.start_time - b.start_time);

            const restHours = {};
            if (lastShiftInPreviousWeek && allShifts.length > 0 && allShifts[0].id !== lastShiftInPreviousWeek.id) {
                const lastShiftInPreviousWeekEndTime = moment(lastShiftInPreviousWeek.end_time);
                const firstShiftInWeekStartTime = moment(allShifts[0].start_time);
                const restDurationHours = firstShiftInWeekStartTime.diff(lastShiftInPreviousWeekEndTime, "hours", true);
                restHours[allShifts[0].id] ??= restDurationHours;
            }
            let maxBreakDurationHours = moment(allShifts[0].start_time).diff(firstDayOfWeek, "hours", true);
            for (let i = 0; i < allShifts.length - 1; i++) {
                const endCurrentShift = moment(allShifts[i].end_time);
                const startNextShift = moment(allShifts[i + 1].start_time);
                const breakDurationHours = startNextShift.diff(endCurrentShift, "hours", true);
                restHours[allShifts[i + 1].id] ??= breakDurationHours;
                if (breakDurationHours > maxBreakDurationHours) {
                    maxBreakDurationHours = breakDurationHours;
                }
            }
            const lastDate = moment(lastDayOfWeek.endTime);
            let lastDuration = lastDate.diff(moment(allShifts[allShifts.length - 1].end_time), "hours", true);
            const maxBreakHours = lastDuration > maxBreakDurationHours ? lastDuration : maxBreakDurationHours;
            return {
                maxBreakDurationHours: maxBreakHours,
                restHours: restHours,
            };
        };

        self.prepareMinorShiftsWarnings = function (startOfWeek) {
            var weekCalenderDays = _workRestrictionsService.getCalenderDays(startOfWeek);
            var weekDaysKeys = Object.keys(weekCalenderDays);
            var lastDayKey = weekDaysKeys[weekDaysKeys.length -1];
            let startCalenderWeek = weekCalenderDays[weekDaysKeys[0]].startTime;
            self.minorsWarning = {};
            self.minorWarningsPerShift = {};
            self.shiftsMinorTypes = {};
            self.shiftsPerUsers = _workRestrictionsService.getFormattedShiftsPerUser();
            let isMinorWorkPermitsEnabled = self.minorWorkPermitsSetting.is_minor_work_permit_enabled;

            for (var userId in self.shiftsPerUsers) {
                var userSchoolCalender = _workRestrictionsService.getUserSchoolCalender('MINOR', userId)
                var userInfo = tsUsersService.users[userId];
                minorUsersWorkMap[userId] = {};

                if (userInfo) {
                    var shiftsPerUser = self.shiftsPerUsers[userId].shifts;
                    if (userSchoolCalender && shiftsPerUser) {
                        const userLastShiftsInLastDayInPreviousWeek = _workRestrictionsService.lastCalenderDayShiftsInPreviousWeekMap[userId];
                        const lastShiftInPreviousWeek = userLastShiftsInLastDayInPreviousWeek?.length > 0 && userLastShiftsInLastDayInPreviousWeek[0];
                        const breakAndRestHours = getMaxDurationHoursBetweenShifts(shiftsPerUser, startCalenderWeek, weekCalenderDays[lastDayKey], userInfo.birth_date, lastShiftInPreviousWeek);
                        minorUsersWorkMap[userId]['maxBreakDurationHours'] = breakAndRestHours?.maxBreakDurationHours;
                        minorUsersWorkMap[userId]['restHours'] = breakAndRestHours?.restHours;
                    }
                    //week in session if at least one day in session
                    minorUsersWorkMap[userId]['isWeekInSession'] = _workRestrictionsService.checkWeekStatus(userSchoolCalender, weekCalenderDays);

                    for (var day in shiftsPerUser) {
                        var userAge = userInfo.getUserAge(day);
                        var isMinor = userInfo && userInfo.isMinor(day);

                        var shiftsPerDay = shiftsPerUser[day];
                        if (userAge && isMinor) {
                            for (var i = 0; i < shiftsPerDay.length; i++) {
                                var shift = shiftsPerDay[i];
                                updateShiftMinorType(shift);
                                var userMinorType = self.shiftsMinorTypes[shift.id];
                                var effectiveEmancipationStatus = self.getEffectiveMinorUserStatus(self.usersMinorEmancipationStatus[shift.user_id], shift.start_time);
                                var isEmancipated = effectiveEmancipationStatus && effectiveEmancipationStatus.is_emancipated;
                                var effectiveRestrictionStatus = self.getEffectiveMinorUserStatus(self.usersMinorRestrictedStatus[shift.user_id], shift.start_time);
                                var minorAgeRulesSet = getMinorRulesSet(self.minorsWorkRules, userAge, userMinorType, isEmancipated, effectiveRestrictionStatus);
                                self.minorWarningsPerShift[shift.id] = self.minorWarningsPerShift[shift.id] || [];

                                if (
                                    moment(shift['startTime']).isSameOrAfter(weekCalenderDays[lastDayKey].endTime) ||
                                    moment(shift['startTime']).isBefore(weekCalenderDays[weekDaysKeys[0]].startTime)
                                ) {
                                    continue;
                                }

                                if (userSchoolCalender && userSchoolCalender[shift['shiftDay']]) {
                                    if (minorAgeRulesSet) {
                                        minorUsersWorkMap[userId] = getMinorUserWork(minorUsersWorkMap[userId], shift, minorAgeRulesSet);
                                        self.minorWarningsPerShift[shift.id] = _workRestrictionsService.getShiftWorkRestrictionsWarnings(userSchoolCalender, minorAgeRulesSet,minorUsersWorkMap[userId], shift);
                                        self.minorsWarning[userId] = self.minorsWarning[userId] || {};
                                        self.minorsWarning[userId] = $.extend(self.minorsWarning[userId], _workRestrictionsService.getEmployeeWorkRestrictionsWarnings(minorAgeRulesSet, minorUsersWorkMap[userId], 'MINOR'));
                                    }
                                }

                                if (userMinorType) {
                                    if (
                                        userMinorType.require_school_template &&
                                        (!userSchoolCalender || !userSchoolCalender[shift.day])
                                    ) {
                                        self.minorWarningsPerShift[shift.id].push({
                                            key: 'MINOR'+ '_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR',
                                            restrictionType: 'MINOR'
                                        });
                                    }
                                } else {
                                    self.minorWarningsPerShift[shift.id].push({
                                        key: 'NO_EFFECTIVE_MINOR_TYPE'
                                    });
                                }
                                if (isMinorWorkPermitsEnabled) {
                                    const shiftDay = moment(shift.start_time).format('MMM DD, YYYY');
                                    let dayInfo = self.minorUsersWorkPermitsMap?.[userId]?.[shiftDay];
                                    let isUserAgeNeedsWorkPermit = self.minorWorkPermitsSetting?.restricted_ages.find((restrictedAge)=> {
                                        return userAge === restrictedAge.from_age;
                                    });
                                    if (isUserAgeNeedsWorkPermit) {
                                        if (!self.minorUsersWorkPermitsMap[userId] || (!dayInfo.has_work_permit && !dayInfo.is_exempt)) {
                                            let userDatesWithoutEffectiveWorkPermits = getNonCompliantWorkPermitDateRange(userId, weekDaysKeys);
                                            self.minorWarningsPerShift[shift.id].push({
                                                key: 'MINOR_NO_EFFECTIVE_WORK_PERMIT',
                                                from_date: userDatesWithoutEffectiveWorkPermits.fromDate,
                                                to_date: userDatesWithoutEffectiveWorkPermits.toDate
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    console.warn('user has no details' + userId)
                }
            }
        };

        var doOverlap = function (shift1, shift2) {
            var shift1Start = new Date(shift1.start_time).getTime();
            var shift2Start = new Date(shift2.start_time).getTime();
            var shift1End = new Date(shift1.end_time).getTime();
            var shift2End = new Date(shift2.end_time).getTime();

            if (
                (shift1Start < shift2Start && shift1End <= shift2Start) ||
                (shift1End > shift2End && shift1Start >= shift2End)
            ) {
                return false;
            }

            return true;
        };

        var isMinorWorkInSchoolTime = function (minorAvailabilities, shift) {
            var isInSchoolTime = false;

            for (var j in minorAvailabilities) {
                var minorAvailability = minorAvailabilities[j];

                if (minorAvailability.type === _workRestrictionsService.PERIOD_TYPES.SCHOOL_DAY && doOverlap(shift, minorAvailability)) {
                    isInSchoolTime = true;
                    break;
                }
            }

            return isInSchoolTime;
        };
        var getMinorUserWork = function (minorUserWork, shift, minorAgeRulesSet) {
            minorUserWork.daysPerWeek ??= {};
            minorUserWork.daysPerWeek[shift.shiftDay] = (minorUserWork.daysPerWeek[shift.shiftDay] ?? 0) + shift.length;

            if (minorAgeRulesSet.maxHoursPerPeriod &&
                minorAgeRulesSet.maxHoursPerPeriod[_workRestrictionsService.PERIOD_REFERENCE_TYPE.SHIFT_END] &&
                minorAgeRulesSet.maxHoursPerPeriod[_workRestrictionsService.PERIOD_REFERENCE_TYPE.SHIFT_END].unit_value) {

                minorUserWork['rollingHours'] = minorUserWork['rollingHours'] || {};
                const lastDayInPreviousWeekShifts = _workRestrictionsService.lastCalenderDayShiftsInPreviousWeekMap[shift.user_id] || [];
                minorUserWork['rollingHours'][shift.id] = getTotalWorkHoursWithinPreviousPeriod(shift, self.shiftsPerUsers[shift.user_id], minorAgeRulesSet.maxHoursPerPeriod[_workRestrictionsService.PERIOD_REFERENCE_TYPE.SHIFT_END].period_length, lastDayInPreviousWeekShifts);
            }
            minorUserWork.hoursPerWeek = (minorUserWork.hoursPerWeek || 0) + shift.length;
            return minorUserWork;
        }

        self.isUserPassMinorRules = (startOfWeek, userId, shifts) => {
            var weekCalenderDays = _workRestrictionsService.getCalenderDays(startOfWeek);
            var weekDaysKeys = Object.keys(weekCalenderDays);
            var lastDayKey = weekDaysKeys[weekDaysKeys.length -1];
            var userInfo = tsUsersService.users[userId];
            var userWorkMap = angular.copy(minorUsersWorkMap[userId]) || {};
            var minorsWarnings = {};

            if (userInfo) {
                let mappedShifts = _workRestrictionsService.getShiftsMap(angular.copy(shifts), true, userId);
                var shiftsPerUser = (mappedShifts[userId] && mappedShifts[userId].shifts) || [];
                var userSchoolCalender = _workRestrictionsService.getUserSchoolCalender('MINOR', userId);
                userWorkMap['isWeekInSession'] = _workRestrictionsService.checkWeekStatus(userSchoolCalender, weekCalenderDays);

                for (var day in shiftsPerUser) {
                    var userAge = userInfo.getUserAge(day);
                    var shiftsPerDay = shiftsPerUser[day];

                    if (userAge) {
                        for (var i = 0; i < shiftsPerDay.length; i++) {
                            var shift = shiftsPerDay[i];
                            var minorWarningsPerShift = [];

                            updateShiftMinorType(shift);
                            var userMinorType = self.shiftsMinorTypes[shift.id];
                            var effectiveEmancipationStatus = self.getEffectiveMinorUserStatus(self.usersMinorEmancipationStatus[shift.user_id], shift.start_time);
                            var isEmancipated = effectiveEmancipationStatus && effectiveEmancipationStatus.is_emancipated;
                            var effectiveRestrictionStatus = self.getEffectiveMinorUserStatus(self.usersMinorRestrictedStatus[shift.user_id], shift.start_time);
                            var minorAgeRulesSet = getMinorRulesSet(self.minorsWorkRules, userAge, userMinorType, isEmancipated, effectiveRestrictionStatus);

                            if (
                                moment(shift['startTime']).isSameOrAfter(weekCalenderDays[lastDayKey].endTime) ||
                                moment(shift['startTime']).isBefore(weekCalenderDays[weekDaysKeys[0]].startTime)
                            ) {
                                continue;
                            }
                            if (userSchoolCalender && userSchoolCalender[shift['shiftDay']]) {
                                if (minorAgeRulesSet) {
                                    userWorkMap = getMinorUserWork(userWorkMap, shift, minorAgeRulesSet);
                                    minorWarningsPerShift = _workRestrictionsService.getShiftWorkRestrictionsWarnings(userSchoolCalender, minorAgeRulesSet, userWorkMap, shift);
                                    if (minorWarningsPerShift.length) {
                                        return false;
                                    }
                                    minorsWarnings = $.extend(minorsWarnings, _workRestrictionsService.getEmployeeWorkRestrictionsWarnings(minorAgeRulesSet, userWorkMap, 'MINOR'));
                                    if (!_.isEmpty(minorsWarnings)) {
                                        return false;
                                    }
                                }
                                var inSchoolTime = isMinorWorkInSchoolTime(userSchoolCalender, shift);
                                if (inSchoolTime) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
            return true;
        };

        self.getMinorRulesViolations = function (usersShifts) {
            var violationsMap = {};

            for (var i in usersShifts) {
                var shift = usersShifts[i];

                if (shift.user_id && shift.status !== 'DELETED') {
                    var userId = shift['user_id'];
                    var minorAvailabilities = _workRestrictionsService.getUserSchoolCalender('MINOR', userId)

                    if (minorAvailabilities && Object.keys(minorAvailabilities).length) {
                        for (var j in minorAvailabilities) {
                            if (
                                minorAvailabilities[j].type === _workRestrictionsService.PERIOD_TYPES.SCHOOL_DAY &&
                                doOverlap(shift, minorAvailabilities[j])
                            ) {
                                violationsMap['IN_SCHOOL_TIME'] = violationsMap['IN_SCHOOL_TIME'] || {
                                    code: 'IN_SCHOOL_TIME',
                                    users: []
                                };
                            }
                        }
                    }

                    if (self.minorsWarning && self.minorsWarning[userId] && Object.keys(self.minorsWarning[userId]).length) {
                        for (var k in self.minorsWarning[userId]) {
                            var minorWarning = self.minorsWarning[userId][k];
                            var minorScheduleKey = minorWarning.key;
                            violationsMap[minorScheduleKey] = violationsMap[minorScheduleKey] || {
                                code: minorScheduleKey,
                                users: []
                            };
                        }
                    }

                    if (self.minorWarningsPerShift[shift.id] && self.minorWarningsPerShift[shift.id].length) {
                        for (var l in self.minorWarningsPerShift[shift.id]) {
                            var minorScheduleKey = self.minorWarningsPerShift[shift.id][l].key;
                            violationsMap[minorScheduleKey] = violationsMap[minorScheduleKey] || {
                                code: minorScheduleKey,
                                users: []
                            };
                        }
                    }
                }
            }

            return Object.keys(violationsMap);
        };

        self.reset = function () {
            self.minorsWorkRules = [];
            self.minorsWarning = {};
            self.minorWarningsPerShift = {};
            self.minorUsersWork = {};
            self.usersMinorTypes = {};
            self.usersMinorEmancipationStatus = {};
            self.shiftsMinorTypes = {};
            minorUsersWorkMap = {};
        };
    }

    app.service('minorSchedulingService', [
        'TSUsersService', 'ShiftTemplateUtils', 'ScheduleDataServiceV2','businessDayUtils', 'workRestrictionsService',
        function (TSUsersService, ShiftTemplateUtils, ScheduleDataServiceV2, businessDayUtils, workRestrictionsService) {
            tsUsersService = TSUsersService;
            shiftTemplateUtils = ShiftTemplateUtils;
            scheduleDataServiceV2 = ScheduleDataServiceV2;
            _workRestrictionsService = workRestrictionsService;
            _businessDayUtils = businessDayUtils;

            return new MinorSchedulingService();
        }
    ]);

})();